import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CheckboxField from "../../Form/CheckboxField";
import HiddenField from "../../Form/HiddenField";
import DateService from "../../../Services/Shared/Date.service";
import InfoItems from "../../UI/InfoItems/InfoItems";
export const getAreaOfStudySaveRequest = (formState) => {
    return {
        id: formState.id,
        active: formState.active,
    };
};
const AreaOfStudyForm = ({ areaOfStudy }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: "id" }), _jsx(InfoItems, { numColumnsLg: 1, numColumnsSmAndSmaller: 1, numColumnsMd: 1, items: [
                    {
                        label: "Name",
                        value: areaOfStudy.name,
                    },
                ] }), _jsx(CheckboxField, { name: "active", label: "Active" }), _jsx(InfoItems, { numColumnsLg: 1, numColumnsSmAndSmaller: 1, numColumnsMd: 1, items: [
                    {
                        label: "Source System ID",
                        value: areaOfStudy.srcSystemId,
                    },
                    {
                        label: "Area Of Study Type",
                        value: areaOfStudy.areaOfStudyType.name,
                    },
                    {
                        label: "SIS Import Created Date",
                        value: DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportCreatedDate),
                    },
                    {
                        label: "SIS Import Modified Date",
                        value: DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportModifiedDate),
                    },
                ] })] }));
};
export default AreaOfStudyForm;
